import React from "react";
import {RowContext, TableContext, TableOperation, TableV2} from "@q4us-sw/q4us-ui/lib/TableV2";
import {TableFilter} from "./filters/TableFilter";
import {MapToFilter} from "../utils/mappings";
import {
    getFeConfig,
    lastInvoice,
    loadEmList,
    sendPersonInfo,
    dashboardUserResetPassword,
    dashboard_users,
    blockEM
} from "../api/api";
import {Button, notification, Select, Space, Tooltip, Modal, Form, Switch, Input, List, Tag} from "antd";
import {MerchantInfoContext} from "../em/Editor";
import {unstable_batchedUpdates} from "react-dom";
import {MerchantInfoContextProvider, MerchantInfoDialog} from "../em/MerchantInfo";
import { useLocation } from 'react-router-dom'
import {UserAddOutlined, SendOutlined} from "@ant-design/icons";

export const EMList = (props) => {
    const [users, setUsers] = React.useState();
    const [open, setOpen] = React.useState(false)
    const [isConfirmVisible, setConfirmVisible] = React.useState(false);
    const [em, setEm] = React.useState();
    const location = useLocation();
    const fetchData = async (values, page = {}) => {
        const filters = MapToFilter(values)
        return await loadEmList({
            tableName: 'em_view',
            orderBy: ['id desc'],
            filter: [...filters],
            page: {size: page.size || 100, from: ((page.current || 1) - 1) * (page.size || 100)}
        }) || {}
    }
    const openNotificationWithIcon = (data) => {
        for (const obj of data) {
            notification[obj.message_type]({
                message: obj.message
            });
        }
    };

    const onFinish = async (values) => {
        const {id} = values
        const res = await dashboardUserResetPassword(id)
        if(res.status === 200){
            notification.success({message: `Reset password link sent successfully`})
        }else{
            notification.error({message: `Failed to send reset password link`})
        }
    };

    const onsubmit = async (values, table) => {
        const {status} = values
        if(status === 'BLOCK') {
            const res = await blockEM(em, false)
            if(res.status === 200) {
                setConfirmVisible(false)
                table?.setLoading(true)
                const tableData = await table?.props.fetchData({schema: table?.props.schema, page: table?.page, options: table?.customData}) || {};
                notification.success({message: `EM blocked successfully`})
                unstable_batchedUpdates(() => {
                    table?.setData(tableData.data?.rows || [])
                    table?.setLoading(false)
                })
            }
            else {
                notification.error({message: `EM blocked failed`})
            }
        }
        else {
            notification.warn({message: `Please enter BLOCK in the text box`})
        }
    };

    return <React.Fragment>
        <MerchantInfoContextProvider>
        <TableV2
            header={<TableFilter schema={'em_filter'} fetch={fetchData}/>}
            fetchConfig={async (schema) => {
                return await getFeConfig(schema)
            }}
            schema={"em_summary"}
            fetchData={async (request) => {
                const {state: {filter} = {}} = location || {}
                return await fetchData(request.options.filter || filter || {}, request.page)
            }}
            action={{
                name: 'due_in',
                title: '',
                options: TableOperation.Custom
            }}
            getCustomAction={(operation) => {
                return <RowContext.Consumer>
                    {row => <Space key={row?.row.id}>
                        <Button disabled={row?.row.due_in == null} onClick={async () => {
                            await lastInvoice(row?.row.id)
                        }}>Invoice</Button>
                        <MerchantInfoContext.Consumer>
                            {
                                em => <Button onClick={async () => {
                                    unstable_batchedUpdates(() => {
                                        em?.setData(row?.row)
                                        em?.setVisible(true)
                                    })
                                }}>
                                    View Info
                                </Button>
                            }
                        </MerchantInfoContext.Consumer>
                        <Tooltip title="Create account for EM dashboard">
                            <Button onClick={async () => {
                                const resp = await sendPersonInfo(row?.row.full_name, row?.row.nominated_email, row?.row.nominated_person, row?.row.nominated_email_secondary, row?.row.nominated_person_secondary, row?.row.id, row?.row.identifier)
                                if(resp){
                                    const {data} = resp
                                    openNotificationWithIcon(data)
                                }
                            }} icon={<UserAddOutlined />} disabled={!row?.row.enabled}/>
                        </Tooltip>
                        <Tooltip placement="bottomLeft" title={'Resend account information'}>
                            <Button icon={<SendOutlined/>} onClick={async () =>{
                                setOpen(true)
                                const {data} = await dashboard_users(`${row?.row.identifier}@${row?.row.id}`);
                                setUsers(data)
                            }}/>
                        </Tooltip>
                        <Tooltip placement="bottomLeft" title={'Block'}>
                            <TableContext.Consumer>
                                {
                                    table => <Switch checked={!(row?.row.enabled)} onClick = {async (value)=>{
                                        if(value === true){
                                            setEm({full_name: row?.row.full_name,  client_id: row?.row.client_id, em_id: row?.row.id, identifier: row?.row.identifier})
                                            setConfirmVisible(true);
                                        }
                                        else {
                                            const res = await blockEM({client_id: row?.row.client_id, em_id: row?.row.id, identifier: row?.row.identifier}, true)
                                            if(res.status === 200){
                                                table?.setLoading(true)
                                                const tableData = await table?.props.fetchData({schema: table?.props.schema, page: table?.page, options: table?.customData}) || {};
                                                notification.success({message: `EM unblocked successfully`})
                                                unstable_batchedUpdates(() => {
                                                    table?.setData(tableData.data?.rows || [])
                                                    table?.setLoading(false)
                                                })
                                            }else{
                                                notification.error({message: `EM unblocked failed`})
                                            }
                                        }
                                    }}/>
                                }

                            </TableContext.Consumer>
                        </Tooltip>
                    </Space>}
                </RowContext.Consumer>
            }}
            customRenderer={{
                available_schemes: (value, row) => {
                    const {non_eu_countries_using_eas_vat_reg} = row
                    const data = [...(value.filter(item => item !== 'NON_EU_SUPPORTED_COUNTRY')), ...non_eu_countries_using_eas_vat_reg]
                    return ( <List
                        grid={{ gutter: 1}}
                        dataSource={data}
                        renderItem={item => (
                            <List.Item.Meta
                            avatar={<Tag color="blue">{item}</Tag>}
                            />
                        )}
                    />);
                }
            }}
            scroll={{x: 'max-content', y: 'calc(100vh - 150px - 95px - 55px)'}}
        >
        <MerchantInfoDialog/>
            <Modal
                onCancel={() => setOpen(false)}
                footer={null}
                closable={true}
                title={'Resend account information'}
                visible={open}
                width={450}
            >
                <Form onFinish={onFinish}>
                    <Form.Item name="id">
                        <Select placeholder="Select email" allowClear>
                            {users?.map((x) => x.enabled && <Select.Option key={x.id}>{x.email}</Select.Option>)}
                        </Select>
                    </Form.Item>
                    <Form.Item>
                        <div style={{display: "flex",flexDirection: 'row-reverse'}}>
                            <Button type="primary" htmlType="submit">
                                Send
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
            <Modal
                onCancel={() => setConfirmVisible(false)}
                footer={null}
                closable={true}
                visible={isConfirmVisible}
            >
                <p> {em?.full_name} will be blocked. Access to dashboard and to EAS solution functionality will be revoked. Are you sure to block client access? Please enter BLOCK in the text box below to proceed.</p>
                <TableContext.Consumer>
                 {
                    table => <Form onFinish={(values) => onsubmit(values, table)}>
                        <Form.Item name="status">
                            <Input />
                        </Form.Item>
                        <Form.Item>
                            <Space>
                                <Button type="primary" htmlType="submit">
                                    Yes
                                </Button>
                                <Button htmlType="button" onClick={async () =>{
                                    setConfirmVisible(false)
                                }}>
                                    No
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>}
                </TableContext.Consumer>
            </Modal>
        </TableV2>
        </MerchantInfoContextProvider>
    </React.Fragment>
}
